import { render, staticRenderFns } from "./favorite-connect-header.vue?vue&type=template&id=92561ebe&scoped=true"
import script from "./favorite-connect-header.vue?vue&type=script&lang=js"
export * from "./favorite-connect-header.vue?vue&type=script&lang=js"
import style0 from "./favorite-connect-header.vue?vue&type=style&index=0&id=92561ebe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92561ebe",
  null
  
)

export default component.exports